import React, { useState, useEffect } from 'react';
import { Skeleton } from '@mui/material';
import { useSpring, animated } from '@react-spring/web';
import { useSelector } from 'react-redux';
import Chart from "react-apexcharts";
import { getCurrencySymbolV2 } from 'utils/currency';

// ✅ Clear
const InvoiceComparisonWidgetComponent = ({ details, isLoading, loadChart }) => {
    const selectedCurrency = useSelector((state) => state.main.selectedCurrency);

    const [openValue, setOpenValue] = useState(0)
    const [paidValue, setPaidValue] = useState(0)
    const [percentage, setPercentage] = useState(0)

    const options = {
        chart: {
        type: "radialBar",
        offsetY: -20
        },
        plotOptions: {
        radialBar: {
            startAngle: -90,
            endAngle: 90,
            hollow: {
            margin: 0,
            size: "70%",
            background: "transparent"
            },
            track: {
            background: "#e7e7e7",
            strokeWidth: "100%",
            margin: 0
            },
            dataLabels: {
            show: false
            }
        }
        },
        stroke: {
        lineCap: "round" // ✅ rounded ends
        },
        labels: ["Achieved"],
        colors: ["#2eca80"]
    };

		const { animatedPaid, animatedOpen } = useSpring({
			from: { animatedPaid: 0, animatedOpen: 0 },
			to: { animatedPaid: paidValue, animatedOpen: openValue },
            delay: 0,
            config: { mass: 1, tension: 120, friction: 14 },
		});

    useEffect(() => {
        if (details) {
            let newTotalValue = (details?.['paid']?.[selectedCurrency === 'all' ? 'usd' : selectedCurrency] || 0) + (details?.['open']?.[selectedCurrency === 'all' ? 'usd' : selectedCurrency] || 0);
            let newPaidValue = details?.['paid']?.[selectedCurrency === 'all' ? 'usd' : selectedCurrency] || 0;
            setOpenValue(details?.['open']?.[selectedCurrency === 'all' ? 'usd' : selectedCurrency] || 0)
            setPaidValue(details?.['paid']?.[selectedCurrency === 'all' ? 'usd' : selectedCurrency] || 0)
            setPercentage(newTotalValue > 0 ? ((newPaidValue / newTotalValue) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)
        }
    }, [details, selectedCurrency, loadChart])

    return (
        <div className="card" style={{ height: '280px' }}>
            <div className="card-body" style={{ padding: '15px', zIndex: '1'}}>
                <div className={`text-lg fw-500`}>
                    Invoice Payment Summary
                </div>
                <div className="flex justify-content-center">
                    <div>

                        <div className="chart-box" style={{ marginTop: '20px' }}>
                            <Chart options={options} series={[percentage]} type="radialBar" height={'200px'} style={{ height: '170px'}} />
                            <div className="flex " style={{ marginTop: '-60px', justifyContent: 'space-around', paddingTop: '20px' }}>
                                <div className="text-center">
                                    {
                                        isLoading ? (
                                            <>
                                                <div className="w-full  flex justify-content-center">
                                                    <div className="mb-1" style={{ width: '75px', marginTop: '5px' }}>
                                                        <Skeleton variant="rounded" width={'100%'} height={15} className={`rounded-full`} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                </div>
                                                <div style={{ width: '150px' }}>
                                                    <Skeleton variant="rounded" width={'100%'} height={25} className={`rounded-full`} style={{ borderRadius: '32px' }} />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="fw-400 mb-1">Paid</div>
                                                <div className="fw-500 text-xl flex gap-1">
                                                    <div style={{ marginTop: `${selectedCurrency === 'aed' ? '-2px' : '0'}` }}>
                                                        {getCurrencySymbolV2(selectedCurrency, 'usd', '18px', '18px')}    
                                                    </div>
                                                    <animated.div>
                                                        {animatedPaid.to((val) => val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}
                                                    </animated.div>
                                                </div>
                                            </>
                                        )
                                    }
                                </div>
                                <div className="text-center" style={{ marginRight: '-5px' }}>
                                    {
                                        isLoading ? (
                                            <>
                                                <div className="w-full  flex justify-content-center">
                                                    <div className="mb-1" style={{ width: '75px', marginTop: '5px' }}>
                                                        <Skeleton variant="rounded" width={'100%'} height={15} className={`rounded-full`} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                </div>
                                                <div style={{ width: '150px' }}>
                                                    <Skeleton variant="rounded" width={'100%'} height={25} className={`rounded-full`} style={{ borderRadius: '32px' }} />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="fw-400 mb-1">Open</div>
                                                <div className="fw-500 text-xl flex gap-1">
                                                    <div style={{ marginTop: `${selectedCurrency === 'aed' ? '-2px' : '0'}` }}>
                                                        {getCurrencySymbolV2(selectedCurrency, 'usd', '18px', '18px')}
                                                    </div>
                                                    <animated.div>
                                                        {animatedOpen.to((val) => val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}
                                                    </animated.div>
                                                </div>
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    )
}


export default InvoiceComparisonWidgetComponent;